import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/pcr-master-mix-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/pcr-master-mix-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/pcr-master-mix-calculator",
      title: m.pcr_meta_title(),
      description: m.pcr_meta_description(),
      toolName: m.pcr_tool_name(),
      faqs: [
        { q: m.pcr_faq_q1(), a: m.pcr_faq_a1() },
        { q: m.pcr_faq_q2(), a: m.pcr_faq_a2() },
        { q: m.pcr_faq_q3(), a: m.pcr_faq_a3() },
        { q: m.pcr_faq_q4(), a: m.pcr_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
